'use client';

import React from 'react';
import SlideWrapper from '../SlideWrapper';
import { Building2 } from 'lucide-react';

interface Props {
  id: string;
  registerRef: (id: string, el: HTMLElement | null) => void;
}

export default function Slide17dSchoolValue4({ id, registerRef }: Props) {
  const cards = [
  {
    title: 'Mở thêm hướng kết nối định hướng nghề nghiệp cho sinh viên sau tốt nghiệp',
    desc: 'Thông qua chương trình, nhà trường không chỉ có một hoạt động ngoại khóa giàu ý nghĩa mà còn có thêm một hướng kết nối thực tế cho sinh viên trong giai đoạn sau đại học.'
  },
  {
    title: 'Được hỗ trợ địa điểm cho team building và tổ chức sự kiện',
    desc: 'Tri An Green Travel có thể đồng hành cùng nhà trường / Đoàn – Hội trong việc hỗ trợ không gian phù hợp để tổ chức team building, sinh hoạt tập thể hoặc các sự kiện sinh viên theo mô hình trải nghiệm xanh.'
  },
  {
    title: 'Có thể phối hợp đào tạo lực lượng đại sứ thương hiệu sinh viên lâu dài',
    desc: 'Tri An Green Travel có thể cùng nhà trường xây dựng nhóm sinh viên nòng cốt hoặc đại sứ thương hiệu sinh viên để tiếp tục đồng hành trong các hoạt động truyền thông, sự kiện và lan tỏa tinh thần sống xanh.'
  }];


  return (
    <SlideWrapper id={id} registerRef={registerRef} className="bg-[#f5f0e8]">
      <div className="relative z-10 max-w-screen-xl mx-auto px-6 lg:px-16 xl:px-24 py-16 min-h-screen flex flex-col justify-center">
        <div className="fade-in-up mb-3">
          <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-[rgba(26,74,42,0.1)] border border-[rgba(26,74,42,0.2)] mb-4">
            <Building2 size={12} className="text-[#1a4a2a]" />
            <span className="text-[11px] font-700 uppercase tracking-widest text-[#1a4a2a] font-body">Dành cho nhà trường / Đoàn – Hội</span>
          </div>
          <h2 className="font-display font-800 text-[clamp(26px,4vw,52px)] leading-[1.1] text-[#1a4a2a] tracking-tight">
            Quyền lợi dành cho nhà trường / Đoàn – Hội
          </h2>
        </div>

        <div className="fade-in-up mb-8">
          <div className="w-[60px] h-[3px] bg-[#1a4a2a] rounded-full" />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 fade-in-up mb-8">
          {cards.map((card, i) =>
          <div
            key={`school17d-${i}`}
            className="rounded-2xl bg-white/70 border border-[rgba(26,74,42,0.2)] p-6 flex flex-col transition-all duration-300 hover:-translate-y-1 hover:shadow-md">

              <h3 className="font-display font-700 text-[16px] text-[#1a4a2a] mb-3 leading-snug">{card.title}</h3>
              <p className="font-body text-[14px] text-[#3a5a3a] leading-relaxed">{card.desc}</p>
            </div>
          )}
        </div>

        <div className="fade-in-up rounded-2xl overflow-hidden h-[260px] md:h-[300px]">
          <img
            src="https://img.rocket.new/generatedImages/rocket_gen_img_123d27dd8-1772259011540.png"
            alt="Nhóm sinh viên ngồi quanh bàn trong rừng, cùng thảo luận bản đồ và kế hoạch hoạt động ngoại khóa"
            className="w-full h-full object-cover" />

        </div>
      </div>
    </SlideWrapper>);

}